import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { useRouteProperties } from '@/hooks/useRouteProperties';
import Breadcrumbs from '@/components/widgets/HeaderWidget/Breadcrumbs/Breadcrumbs.component';
import { getLinks } from '@/components/widgets/HeaderWidget/HeaderWidget.config';
import styles from '@/components/widgets/HeaderWidget/HeaderWidget.module.scss';
import MainHeader from '@/components/widgets/HeaderWidget/MainHeader/MainHeader.component';

const HeaderWidget: FC = () => {
    const { pathname, state } = useLocation();
    const { isHideHeader } = useRouteProperties();

    const backLinks = getLinks(pathname, state?.headerLabel);

    if (isHideHeader) {
        return;
    }

    return (
        <header className={styles.headerWidgetWrapper}>
            {backLinks ? <Breadcrumbs backLinks={backLinks} /> : <MainHeader />}
        </header>
    );
};

export default HeaderWidget;
